import React from "react"
import { Theme, Button, createStyles, makeStyles } from "@material-ui/core"
import { useState } from "react"
import ContactFormDialog from "../ContactForm/ContactFormDialog"
import { InsuranceType } from "../../helpers/insurance"
import PersonalAccidentsInsuranceCardImg from "../../images/personal-accidents-insurance-card-img.png"
import SevereIllnessInsuranceCardImg from "../../images/severe-illness-insurance-card-img.png"
import NursingInsuranceCardImg from "../../images/nursing-insurance-card-img.png"
import HealthInsuranceCardImg from "../../images/health-insurance-card-img.png"
import LossOfWorkFitnessInsuranceCardImg from "../../images/loss-of-work-fitness-insurance-card-img.png"
import LifeInsuranceCardImg from "../../images/life-insurance-card-img.png"


const useStyles = makeStyles((theme: Theme) => createStyles({
    root:{
        textAlign:'center',
        padding: 10,
        width: 'calc(100% - 20px)',
    },
    header:{
        color:'#165372',
        fontSize: '3em'
    },
    cards:{
    },
    card:{
        margin: 10,
        width: 'calc((100% / 3) - 24px)',
        [theme.breakpoints.down('md')]:{
            width: 'calc((100% / 2) - 24px)'
        },
        [theme.breakpoints.down(750)]:{
            width: 'calc(100% - 24px)'
        },
    },
    link:{
        display: 'inline-block',
        color: theme.palette.primary.main,
        textDecoration: 'underline',
        cursor:'pointer',
        '&:hover': {
            opacity:'50%'
            }
    },
    button:{ 
        backgroundColor: '#F76C05',
        color: 'white',
        borderRadius: 15,
        border: '3px solid white',
        fontSize:'1.1em',
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop: 4,
        paddingBottom: 4,
        marginTop: -20
    },
    triangleDown:{
        width:0,
        marginRight: 'calc(50% - 15px)',
        marginBottom: 15,
        borderLeft: '20px solid transparent',
        borderRight: '20px solid transparent',
        borderTop: '30px solid #165372',
      }
}))

interface InsuranceCardProps {
    className?: string
    image:string,
    title:string,
    description:string,
    insurance?: InsuranceType,
    processLinkCaption?: string
}

const InsuranceCard = (props: InsuranceCardProps) => {
    const { className, image, title, description, insurance, processLinkCaption} = props
    const [startProcess, setStartProcess] = useState(false)

    let classes = useStyles()

    return <div className={classes.card + ((className) ? ' ' + className : '')} style={{textAlign:'center'}}>
        <div style={{ backgroundSize: 'cover', backgroundPosition: 'center', 
                      backgroundRepeat: 'no-repeat', backgroundImage: `url(${image})`,
                      borderRadius: 10,
                      width: '100%', height: 270}}/>
        <div style={{borderRadius: 10, marginTop:4, marginBottom:4,
                     backgroundImage: "linear-gradient(#5A889F,#165372)", color:'white'}}>
            <h2 style={{margin: 4}}>{title}</h2>
        </div>
        <div style={{ backgroundColor:'#54849A', borderRadius: 10, paddingBottom:10 }}>
            <p style={{paddingLeft:5, paddingRight:5, fontSize:'0.9em', color: 'white' }}>{description}</p>
        </div>
        {(insurance !== undefined) &&
        <>
            <Button variant="contained" className={classes.button} onClick={() => (insurance !== undefined) && setStartProcess(true)}>
                {processLinkCaption}
            </Button>
            <ContactFormDialog insurance={insurance} open={startProcess} onClose={() => setStartProcess(false)}/>
        </>}
    </div>
}

export const HealthInsuranceCard = (props: { className?: string }) =>{
    return <InsuranceCard 
        image={HealthInsuranceCardImg}
        title="ביטוח בריאות"
        description="ביטוח המעניק כיסוי בסיסי בהתאם לצרכים הייחודיים שלכם, ועשוי לחסוך לכם עשרות ואף מאות אלפי שקלים. בין הכיסויים תוכלו למצוא תרופות, השתלות, ניתוחים, שירותים אמבולטוריים, שיקום, ושירותים רפואיים נוספים."
        insurance={'health_insurance'}
        processLinkCaption='להשוואת ביטוח בריאות'
        className={props.className}/>
}

export const LifeInsuranceCard = (props: { className?: string }) => { 
    return <InsuranceCard 
        image={LifeInsuranceCardImg}
        title="ביטוח חיים"
        description="ביטוח חיים מאפשר לכל אדם להגן כלכלית על משפחתו במקרה של פטירה. ניתן לרכוש ביטוח חיים כפרמיה משתנה או כקצבה. הביטוח מותאם אישית ומהווה בחירה מדויקת, חסכונית וחכמה שתעניק ביטחון כלכלי למשפחתכם."
        insurance={'life_insurance'}
        processLinkCaption='להשוואת ביטוח חיים'
        className={props.className}/>
}

export const PersonalAccidentsInsuranceCard = (props: { className?: string }) => {
    return <InsuranceCard
        image={PersonalAccidentsInsuranceCardImg}
        title="ביטוח תאונות אישיות"
        description="ביטוח זה נועד להגן עליכם במקרה של תאונה, והוא מכסה את המבוטח בזמן מוות, נכות או אובדן כושר עבודה. ביטוח זה שונה מביטוח בריאות, מכיוון שהוא מזכה את המבוטח בתשלום חד פעמי בעת הימצאות אחד מהמצבים המוגדרים בפוליסה."
        insurance={'personal_accidents_insurance'}
        processLinkCaption='להשוואת ביטוח תאונות אישיות'
        className={props.className}/>
}

export const LossOfWorkFitnessInsuranceCard = (props: { className?: string }) => {
    return <InsuranceCard 
        image={LossOfWorkFitnessInsuranceCardImg}
		title="ביטוח אובדן כושר עבודה"
        description="ביטוח זה, כשמו כן הוא, יגן עליכם במקרה בו תיפגע יכולתכם לעבוד עקב תאונה או מחלה. במסגרת הביטוח תוכלו לקבל פיצוי חודשי אשר יחליף את הכנסתכם החודשית, עד לתקרה של 75% מהמשכורת שלכם."
        insurance={'loss_of_work_fitness_insurance'}
        processLinkCaption='להשוואת ביטוח אובדן כושר עבודה'
        className={props.className}/>
}

export const SevereIllnessInsuranceCard = (props: { className?: string }) => {
    return <InsuranceCard 
        image={SevereIllnessInsuranceCardImg}
		title="ביטוח מחלות קשות"
        description="ביטוח המזכה את המבוטח בסכום כסף חד פעמי, במידה ומתגלה אצלו מחלה קשה, או במקרה שהוא עובר אירוע רפואי קשה. ביטוח זה שונה מביטוח הבריאות שעובד במודל של החזר על הוצאות רפואיות."
        insurance={'severe_illness_insurance'}
        processLinkCaption='להשוואת ביטוח מחלות קשות'
        className={props.className}/>
}
          
export const NursingInsuranceCard = (props: { className?: string }) => {
    return <InsuranceCard 
        image={NursingInsuranceCardImg}
		title="ביטוח סיעודי"
        description="ביטוח סיעודי מאפשר את הרחבת הקצבה למטופלים סיעודיים, ולכן הוא חשוב במיוחד עבור אוכלוסיית הגיל השלישי, אך רלוונטי גם בגילאים צעירים יותר."
        className={props.className}/>
}

const InsurancesCardsPageRow = () => {
    
    let classes = useStyles()

    return (
        <div className={classes.root}>
            <h1 className={classes.header}>מגוון הביטוחים שנוכל לבדוק עבורכם</h1>
            <div className={classes.triangleDown}/>
            <div className={classes.cards}>
                <HealthInsuranceCard/>
                <LifeInsuranceCard/>
                <PersonalAccidentsInsuranceCard/>
                <LossOfWorkFitnessInsuranceCard/>
                <SevereIllnessInsuranceCard/>
                <NursingInsuranceCard/>
            </div>
        </div>
    );
}

export default InsurancesCardsPageRow